import type { BaseComment } from '../types';

export function getReplyMention(
  reply?: Pick<BaseComment, 'anonymousDisplay' | 'user'>
): string | undefined {
  return reply?.anonymousDisplay ? undefined : reply?.user.id;
}
